import { render, staticRenderFns } from "./PackagingTypesHead.vue?vue&type=template&id=3c98cca2&scoped=true"
import script from "./PackagingTypesHead.vue?vue&type=script&lang=js"
export * from "./PackagingTypesHead.vue?vue&type=script&lang=js"
import style0 from "./PackagingTypesHead.vue?vue&type=style&index=0&id=3c98cca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98cca2",
  null
  
)

export default component.exports